import { createFileRoute } from "@tanstack/react-router";

import { RescheduleScreen } from "@/modules/coaching/reschedule-sessions/screens/RescheduleScreen";
import { rescheduleSessionLoader } from "@/modules/coaching/reschedule-sessions/utils/rescheduleSessionLoader";

export const Route = createFileRoute(
  "/$sessionCode/reschedule/$rescheduleUuid",
)({
  component: RescheduleScreen,
  loader: rescheduleSessionLoader,
});
